class EstimatedShipping extends HTMLElement {
  constructor() {
    super();

    const shippingElement = this;
    const shippingDateHolderElement =
      shippingElement.querySelector(".shipping-date");
    const shippingCorrectionValue = shippingElement.dataset.shippingCorrection;
    const currentDate = new Date();
    const currentHour = currentDate.getHours();
    const currentDay = currentDate.getDay();
    const shippingThresholdHour = 10;
    const dateOptions = {
      day: "numeric",
      month: "long",
    };

    let shippingDays = 0;

    const calculateShippingDate = (stock, stockIncreasedThreshold) => {
      // Check if the current hour is before the shipping treshold hour (10 hours).
      if (currentHour < shippingThresholdHour) {
        // Ship the same day.
        shippingDays = 0;
      } else {
        // Shipping starts tomorrow.
        shippingDays = 1;
      }

      // If today is Friday shipping start on Monday.
      if (currentDay == 5) {
        shippingDays = 3;
      } else if (currentDay == 6) {
        // If today is Saturday shipping start on Monday.
        shippingDays = 2;
      } else if (currentDay == 7) {
        // If today is Sunday shipping start on Monday.
        shippingDays = 1;
      }

      // If there is a shipping correction add that to the shipping days.
      if (shippingCorrectionValue) {
        shippingDays += Number(shippingCorrectionValue);
      }

      // Add the days to the date. For the stock correction
      const defaultStockThreshold = 5;
      const stockThreshold = stockIncreasedThreshold
        ? parseFloat(stockIncreasedThreshold)
        : defaultStockThreshold;

      if (parseFloat(stock) <= 0) {
        shippingDays += 7;
      } else if (stock <= stockThreshold) {
        shippingDays += 4;
      }
      // if (extraShippingDays) {
      //   shippingDays += shippingDays + extraShippingDays;
      // }
      return shippingDays;
    };
    // console.log(shippingDays + ' shipping days');
    calculateShippingDate();

    // Should probably create an array for this nonsense
    const productShipping = document.querySelector(
      ".product-usps estimated-shipping"
    );

    const cartShipping = document.querySelector("#card-shipping");
    const chfExtraDays = parseFloat(this.dataset.extradayschf);
    if (chfExtraDays == 0) {
      window.addEventListener("load", () => {
        const shippingDateHolderElement = this.querySelector(".shipping-date");
        const extraShippingDays = parseFloat(this.dataset.shippingdays);
        const stockStatus = this.dataset.stockStatus;
        const stock = this.dataset.stock;
        const stockIncreasedThreshold = this.dataset.stockIncreasedThreshold;
        const shippingDate = new Date();
        let shippingDays = calculateShippingDate(
          stock,
          stockIncreasedThreshold
        );
        if (extraShippingDays > 0) {
          shippingDays = shippingDays + extraShippingDays;
        }
        shippingDate.setDate(shippingDate.getDate() + shippingDays);

        shippingDateHolderElement.innerHTML = shippingDate.toLocaleDateString(
          "en-NI",
          dateOptions
        );
      });
    }

    if (cartShipping) {
      cartShipping.addEventListener("changeDateInput", () => {
        const shippingDateHolderElement = this.querySelector(".shipping-date");
        const extraShippingDays = parseFloat(this.dataset.shippingdays);
        const stockStatus = this.dataset.stockStatus;
        const stock = this.dataset.stock;
        const stockIncreasedThreshold = this.dataset.stockIncreasedThreshold;
        const shippingDate = new Date();
        const chfExtraDays = parseFloat(this.dataset.extradayschf);

        let shippingDays = calculateShippingDate(
          stock,
          stockIncreasedThreshold
        );
        if (extraShippingDays > 0) {
          shippingDays = shippingDays + extraShippingDays;
        }
        if (chfExtraDays > 0) {
          shippingDays = shippingDays + chfExtraDays;
        }
        shippingDate.setDate(shippingDate.getDate() + shippingDays);

        shippingDateHolderElement.innerHTML = shippingDate.toLocaleDateString(
          "en-NI",
          dateOptions
        );
      });
    }

    // Make it dynamic for the product details page
    if (productShipping) {
      productShipping.addEventListener("changeDateInput", () => {
        const shippingDateLabelElement = this.querySelector(".shipping-label");
        const shippingDateHolderElement = this.querySelector(".shipping-date");
        const stockStatus = this.dataset.stockStatus; // deprecated
        const stock = this.dataset.stock;
        const stockIncreasedThreshold = this.dataset.stockIncreasedThreshold;
        const shippingDate = new Date();
        const extraShippingDays = parseFloat(
          this.dataset.shippingdaysproductpage
        );
        const chfExtraDays = parseFloat(this.dataset.extradayschf);

        //console.log(stock)
        //console.log(stockIncreasedThreshold)
        let shippingDays = calculateShippingDate(
          stock,
          stockIncreasedThreshold
        );
        if (extraShippingDays > 0) {
          shippingDays = shippingDays + extraShippingDays;
        }
        if (chfExtraDays > 0) {
          shippingDays = shippingDays + chfExtraDays;
        }

        shippingDate.setDate(shippingDate.getDate() + shippingDays);
        shippingDateHolderElement.innerHTML = shippingDate.toLocaleDateString(
          "en-NI",
          dateOptions
        );

        if (shippingDateLabelElement) {
          if (chfExtraDays > 1 && shippingDays > 6) {
            shippingDateLabelElement.innerHTML = "Low stock";
          } 
           else if (chfExtraDays > 1) {
            shippingDateLabelElement.innerHTML = "In stock";
          }
          else if (shippingDays > 3) {
            shippingDateLabelElement.innerHTML = "Low stock";
          } else {
            shippingDateLabelElement.innerHTML = "In stock";
          }
        }
      });
    }
  }
}

// Check if element is defined, if not define it..
// eslint-disable-next-line no-undefined
if (customElements.get("estimated-shipping") === undefined) {
  customElements.define("estimated-shipping", EstimatedShipping);
}
